'use client';
import cn from 'classnames';
import { Toaster as HotToaster } from 'react-hot-toast';

import './Toaster.style.scss';

type ToasterProps = {
  className?: string;
};

function Toaster(props: ToasterProps) {
  const { className = '' } = props;

  return (
    <HotToaster
      containerClassName={cn('Toaster', className)}
      position='top-right'
      toastOptions={{
        className: 'Toaster-toast'
      }}
    />
  );
}

export default Toaster;
